module.exports = __webpack_public_path__ + "img/news-list-ukr-1.ff70e9c6.png";